import {CreateIssueButton} from '@github-ui/issue-create/CreateIssueButton'
import {JobInfoWithSubscription} from '@github-ui/issues-bulk-actions/JobInfoWithSubscription'
import {useFeatureFlag} from '@github-ui/react-core/use-feature-flag'
import {useParams} from '@github-ui/react-router'
import {RepositorySavedViewContent} from '@github-ui/saved-views/components/detail/RepositorySavedViewContent'
import {useNavigate} from '@github-ui/use-navigate'
import {useEffect} from 'react'

import {renderIssuesSidebar} from '../../components/sidebar/render-issues-sidebar'
import {SavedViewIssueList} from '../../components/views/SavedViewIssueList'
import {useQueryBulk} from '../../contexts/QueryContext'
import {IssueShowPage, IssueViewsPage} from '../../lazy-routes'
import {preloadWhenIdle} from '../../utils/preload-when-idle'
import {AnalyticsWrapper} from '../AnalyticsWrapper'

export function RepositorySavedViewPage() {
  const {owner = '', repo = ''} = useParams<{owner: string; repo: string}>()
  useEffect(() => {
    return preloadWhenIdle(() => {
      IssueViewsPage.preload()
      IssueShowPage.preload()
    })
  }, [])

  const {bulkJobId, setBulkJobId, triggerBulkJobSuccess} = useQueryBulk()
  // eslint-disable-next-line @github-ui/github-monorepo/no-use-feature-flags -- issue_pinned_views uses actor-aware server-side evaluation via PinnedViewsFeature; isFeatureEnabled only knows current_user.
  const pinEnabled = useFeatureFlag('issue_pinned_views')
  const IssuesRenderer = SavedViewIssueList
  const navigate = useNavigate()

  return (
    <AnalyticsWrapper category="Repository Saved View">
      <JobInfoWithSubscription bulkJobId={bulkJobId} setBulkJobId={setBulkJobId} onSuccess={triggerBulkJobSuccess}>
        <RepositorySavedViewContent
          IssuesRenderer={IssuesRenderer}
          pinEnabled={pinEnabled}
          renderSidebar={renderIssuesSidebar}
          renderCreateIssueButton={() => (
            <CreateIssueButton
              label="New issue"
              navigate={navigate}
              optionConfig={{
                issueCreateArguments: {repository: {owner, name: repo}},
                showRepositoryPicker: false,
                showFullScreenButton: true,
                canBypassTemplateSelection: true,
                navigate,
              }}
            />
          )}
        />
      </JobInfoWithSubscription>
    </AnalyticsWrapper>
  )
}
